import React, { useEffect, useState, useCallback } from 'react';
import Layout from '../components/Layout';
import { API_BASE_URL } from '../config';
import apiFetch from '../utils/apiFetch';

function PartnerStoreChecklist() {
  const [stores, setStores] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [prefecture, setPrefecture] = useState('');
  const [keyword, setKeyword] = useState('');

  const fetchStores = useCallback(async () => {
    setLoading(true);
    const params = new URLSearchParams({ limit: '50' });
    if (prefecture) params.set('prefecture', prefecture);
    if (keyword) params.set('q', keyword);

    try {
      const res = await apiFetch(`${API_BASE_URL}/admin/partner/stores?${params}`);
      const json = await res.json();
      const d = json.data || json;
      setStores(d.items || []);
      setTotal(d.total || 0);
    } catch {
      // handled
    } finally {
      setLoading(false);
    }
  }, [prefecture, keyword]);

  useEffect(() => {
    fetchStores();
  }, [fetchStores]);

  return (
    <Layout>
      <h4 className="mb-4 fw-bold">Store Checklist</h4>

      <div className="d-flex gap-2 mb-3">
        <input
          className="form-control form-control-sm"
          style={{ maxWidth: 200 }}
          placeholder="Prefecture"
          value={prefecture}
          onChange={(e) => setPrefecture(e.target.value)}
        />
        <input
          className="form-control form-control-sm"
          style={{ maxWidth: 260 }}
          placeholder="Search store name..."
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
        />
        <span className="text-muted align-self-center" style={{ fontSize: '0.8125rem', whiteSpace: 'nowrap' }}>
          {total} stores
        </span>
      </div>

      {loading ? (
        <div className="text-center py-5">Loading...</div>
      ) : (
        <div className="card">
          <div className="card-body p-0">
            <table className="table table-hover table-sm mb-0" style={{ fontSize: '0.8125rem' }}>
              <thead className="table-light">
                <tr>
                  <th>Store Name</th>
                  <th>Address</th>
                  <th>Prefecture</th>
                  <th>Status</th>
                  <th>Cranes</th>
                </tr>
              </thead>
              <tbody>
                {stores.map((s) => (
                  <tr key={s.id}>
                    <td className="fw-semibold">{s.name}</td>
                    <td style={{ maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {s.address}
                    </td>
                    <td>{s.prefecture}</td>
                    <td>
                      <span className={`badge bg-${s.status === 'active' ? 'success' : 'secondary'}`}>
                        {s.status}
                      </span>
                    </td>
                    <td>{s.craneCount || 0}</td>
                  </tr>
                ))}
                {stores.length === 0 && (
                  <tr><td colSpan={5} className="text-center text-muted py-4">No stores found</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </Layout>
  );
}

export default PartnerStoreChecklist;
